import localForage from 'localforage';

import LocalForageKeys from './local-forage.keys';
import { ddlog } from './miscellaneous';
type KEYS = keyof LocalForageKeys;

const localForageWrapper = {
  ...localForage,
  getItem: async <T extends KEYS>(key: T): Promise<LocalForageKeys[T] | null> => {
    try {
      return localForage.getItem(key);
    } catch (error) {
      ddlog.warn('Error in localForage(GET):', { error });
      return null;
    }
  },
  setItem: async <T extends KEYS>(key: T, value: LocalForageKeys[T]) => {
    try {
      return localForage.setItem(key, value);
    } catch (error) {
      ddlog.warn('Error in localForage(SET):', { error });
    }
  },
  removeItem: async <T extends KEYS>(key: T) => {
    try {
      return localForage.removeItem(key);
    } catch (error) {
      ddlog.warn('Error in localForage(REMOVE):', { error });
    }
  },
};

export default localForageWrapper;
